import clsx from "classnames";
import classes from "./styles.module.scss";

export default function ContactButton({ className, icon="", href="", alt="", hoverType="light", buttonSize="32px", iconSize="12px" }) {


  return (
    <a className={clsx(className, classes.button, hoverType === 'light' ? classes.light : classes.dark)} style={{height: buttonSize, width: buttonSize}} href={href} target="_blank" rel="nofollow">
      <img src={icon} alt={alt} style={{height: iconSize, width: iconSize}}></img>
    </a>
  );
}

ContactButton.defaultProps = {
  className: "",
};
